import { render, staticRenderFns } from "./ScratchCardEntry.vue?vue&type=template&id=fca2d3a8"
import script from "./ScratchCardEntry.vue?vue&type=script&lang=js"
export * from "./ScratchCardEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports